import { render, staticRenderFns } from "./insureOrderQuery.vue?vue&type=template&id=a9fedf24&scoped=true"
import script from "./insureOrderQuery.vue?vue&type=script&lang=js"
export * from "./insureOrderQuery.vue?vue&type=script&lang=js"
import style0 from "./insureOrderQuery.vue?vue&type=style&index=0&id=a9fedf24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fedf24",
  null
  
)

export default component.exports